import React from 'react';
import styled from 'styled-components';
import { Colors, NavItems, NavSeparator, Spacer } from '../../utils/budget-tool-specific';
import MonikerIcon from '../../assets/images/moniker-logo-white.png';
import NavItem from './nav-item';

const AppLayout = (props) => {
    const { collapsed, windowSize, setCollapsed, client, isRebelPage, children } = props;

    const getNavItemElement = (item, key) => {
        let path = window.location.pathname;
        let fontColor = Colors.primaryXLight;
        // Use exact URL matching to avoid substring conflicts
        const urlPattern = `/budget-app/${item[1].urlify}`;
        if (path === urlPattern || path.startsWith(urlPattern + '/')) {
            fontColor = Colors.primaryAccent;
        }
        return (
            <NavItem item={item[1]} fontColor={fontColor} key={key} collapsed={collapsed}/>
        )
    }

    const renderNavItemsWithSeparators = () => {
        return Object.entries(NavItems).map((item, key) => {
            const navItem = getNavItemElement(item, key);
            const elements = [navItem];

            // Add separator after this item if it has separatorAfter property
            if (item[1].separatorAfter && !collapsed) {
                elements.push(<NavSeparator key={`separator-${key}`} />);
            }

            return elements;
        }).flat();
    }

    const navigateHome = () => {
        if (!client) {
            window.location = "/budget-app";
        }
    }

    return (
        <AppLayoutContainer>
            <HeaderRow>
                <StyledHeader>
                    <Banner>
                        <BannerImage src={MonikerIcon} onClick={() => navigateHome()}/>
                        {collapsed && !client && (
                            <CollapsedNav>
                                {Object.entries(NavItems).map((item, key) => {
                                    return getNavItemElement(item, key);
                                })}
                            </CollapsedNav>
                        )}
                    </Banner>
                </StyledHeader>
            </HeaderRow>

            <MainRow>
                {!collapsed && (
                    <SidebarColumn>
                        <Spacer height="25px"/>
                        {!client && renderNavItemsWithSeparators()}
                        <VerticalSwooshImage src={"https://cdn.moniker-virtual.com/images/banners/vertical-swoosh.png"}/>
                    </SidebarColumn>
                )}

                <ContentColumn collapsed={collapsed} isRebelPage={isRebelPage}>
                    {children}
                </ContentColumn>
            </MainRow>
        </AppLayoutContainer>
    );
};

export default AppLayout;

const AppLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background-color: ${Colors.primaryLight};
    box-sizing: border-box;
`;

const HeaderRow = styled.div`
    flex-shrink: 0;
    height: 60px;
    width: 100%;
    z-index: 1000;
`;

const StyledHeader = styled.div`
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(46,46,46,1) 92%, rgba(59,59,59,1) 100%);
    box-sizing: border-box;
`;

const Banner = styled.div`
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
`;

const BannerImage = styled.img`
    height: 25px;
    margin: 15px;
    z-index: 1002;
    position: relative;
    &:hover {
        cursor: pointer;
    }
`;

const CollapsedNav = styled.div`
    margin-left: 140px;
    display: flex;
`;

const MainRow = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;
    min-height: 0;
`;

const SidebarColumn = styled.div`
    position: relative;
    width: 190px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    background: linear-gradient(150deg, rgba(0,0,0,1) 30%, rgba(50,50,50,1) 60%, rgba(91,91,91,1) 100%);
    overflow-y: auto;
    overflow-x: hidden;
`;

const VerticalSwooshImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 190px;
    object-fit: none;
    z-index: 1000;
    pointer-events: none;
`;

const ContentColumn = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: ${props => props.isRebelPage ? '#1a1a1a' : Colors.primaryLight};
    min-width: 0;
    box-sizing: border-box;
`;
